<template>
  <div class="view-plan-model-container">
    <b-modal id="viewPlanModal" modal-class="view-plan-modal" size="lg" hide-footer @shown="restViewPlanModel()">
      <template #modal-header>
        <div class="view-plan-header">
          <b-button variant="close-btn" @click="closeModal">
            <i class="fas fa-times"></i>
          </b-button>
        </div>
      </template>
      <b-container fluid>
        <div class="view-plan-modal-content">
          <div class="select-container">
            <label class="required"><strong>Choose Platform</strong></label>
            <!-- {{ platformInfo }} -->
            <div class="mt-2">
              <select name="" class="select-drop-down" @change="checkGroupValidation(platformId)"
                :class="{ 'form-invalid': platformInvaild }" v-model="platformId" id="platform_id">
                <option value="" disabled> Select Platform</option>
                <option v-for="item in platformInfo" :value="item.gid" v-bind:key="item.gid">{{ item.gname }}</option>
              </select>
              <div class="form-error text-left ml-3 mt-2" v-if="platformInvaild">
                Field is required
              </div>
            </div>
          </div>
          <div v-if="platformId" class="select-container">
            <label class="required"><strong>Choose Group</strong></label>
            <div class="mt-2">
              <select name="" class="select-drop-down" :class="{ 'form-invalid': groupInvaild }" v-model="groupDetailId" @change="groupSelectd()"
                id="group_id">
                <option value="" disabled> Select Platform</option>
                <option v-for="group in groupList" :value="group.gid" v-bind:key="group.gid">{{ group.gname }}</option>
              </select>
              <div class="form-error text-left ml-3 mt-2" v-if="groupInvaild">
                Field is required
              </div>
            </div>
          </div>
          <div class="btn-container">
            <button class="view-plans" @click="routeToPlanView">View Plans</button>
          </div>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import endpoint from "@/resource/EndPoints/endpoints"
// import Api from "@/resource/Api";
// import axios from "axios";
// import axios from "axios";
export default {
  name: "ViewPlansModal",
  props: {
    platformInfo: {
      required: true,
    },
    repInfo: {
      required: true
    }
  },
  data () {
    return {
      groupDetailId: '',
      groupList: [],
      platformId: '',
      groupInvaild: false,
      platformInvaild: false,
      agentIdEncrypted: '',
      platformIdEncrypted: '',
      loader: null,
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("viewPlanModal");
      this.$emit("onClosedModal");
    },
    restViewPlanModel () {
      this.groupInvaild = false
      this.platformInvaild = false
      this.groupDetailId = ''
      this.platformId =''
      fetch(endpoint.BENEFIT_STORE_API+"/api/v1/encrypt-info?data="+ this.repInfo.id, {
        method: "POST",
        headers: {
          "Authorization": process.env.VUE_APP_BENEFIT_STORE_API_KEY,
          //  "Content-Type": "application/json"
        },
        // data: { data: this.repInfo.id }
      }).then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.text();
        // return response; // Convert response to JSON
      }).then(data => {
          this.agentIdEncrypted = data; // Assign the response to the Vue data property
        })

      
    },
    routeToPlanView () {
      if (this.platformId == '') {
        this.platformInvaild = true
        console.log('platformInvaild', this.platformInvaild);
        

      }
      if (this.groupList.length>0 && this.groupDetailId == '') {
        this.groupInvaild = true
        console.log('groupInvaild', this.groupInvaild);
        
      }

      if (!this.platformInvaild && !this.groupInvaild) {
        let benefitStoreLink = `${endpoint.BENEFIT_STORE_URL}/view-plans`;

        // Encrypt agent ID using btoa()
        let agentIdEncrypted = this.repInfo.id ? btoa(this.repInfo.id) : null;
        let platformId = this.platformIdEncrypted || null;
        let groupDetailId = this.groupDetailId || null;


        // Build URL dynamically by appending only available values
        if (agentIdEncrypted) benefitStoreLink += `/${agentIdEncrypted}`;
        if (groupDetailId) benefitStoreLink += `/${groupDetailId}`;
        if (groupDetailId && platformId) benefitStoreLink += `/${platformId}`;

        console.log("Generated URL:", benefitStoreLink);

        // Open link only if there's at least one valid parameter
        if (agentIdEncrypted || groupDetailId || platformId) {
          window.open(benefitStoreLink, '_blank');
          this.$bvModal.hide("viewPlanModal");
        } else {
          console.log("No valid parameters to generate the URL.");
        }
      }

    },


    async checkGroupValidation(id) {

      this.platformInvaild = false;
      // let statId ="eyJpdiI6IlNhdlJLZUQzNGt6Z04rQU8rSnpYWVE9PSIsInZhbHVlIjoiaW42cFFQaVdGdTdEaG5hSmV5cTFqUT09IiwibWFjIjoiYWQ1ODU0MjQ0OTVmMmRiMWQzN2I4NTM4ZjQ2NWFlN2VlZjEwNTIwZmMyNWQ4MDA0OTUyNjI3YTAwNzI1ZTE1ZiJ9"

      fetch(endpoint.BENEFIT_STORE_API+"/api/v1/encrypt-info?data=" + id, {
        method: "POST",
        headers: {
          "Authorization": process.env.VUE_APP_BENEFIT_STORE_API_KEY,
          //  "Content-Type": "application/json"
        },
        // data: { data: this.repInfo.id }
      }).then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.text();
        // return response; // Convert response to JSON
      })
        .then(data => {
          this.platformIdEncrypted = data; // Assign the response to the Vue data property

          fetch(endpoint.BENEFIT_STORE_API+"/api/v1/get-agent-groups?from_rep_dashboard=1&agent_id=" + this.agentIdEncrypted+'&platform_group_id='+this.platformIdEncrypted, {
            // method: "POST",
            headers: {
              "Authorization": process.env.VUE_APP_BENEFIT_STORE_API_KEY,
              //  "Content-Type": "application/json"
            },
          }).then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.text();
            // return response; // Convert response to JSON
          }).then(data => {
              const parsedData = JSON.parse(data);
              this.groupList = parsedData.data; // Assign the response to the Vue data property
            })
        })
    },
    groupSelectd() {
      this.groupInvaild = false;
    }

  }
}
</script>

<style scoped>
.select-drop-down {
  padding: 6px;
  width: 100%;
  border: 1px solid #ced4da;
  background-color: #fff;
  border-radius: 5px;
}
.select-drop-down:focus {
  border: 1px solid #ced4da;
}
.select-container {
  padding-bottom: 10px;
}
.btn-container {
  padding-top: 8px;
  width: 40%;
  @media (max-width: 992px) {
    width: 100%;
  }
}
.form-invalid {
  border: 1px solid #ff0000 !important;
}
.form-invalid:focus {
  border: 1px solid #ff0000 !important;
  box-shadow: 0 0 0 0.2rem rgb(255 0 0 / 25%);
}
.form-error {
  color: #ff0000;
}
input:focus, textarea:focus, select:focus{
  outline: none;
}
.required:after {
  content:" *";
  color: #ff0000;
}
</style>
